export enum Status {
    PENDING = 'PENDING',
    SUBMITTED = 'SUBMITTED'
}
